import React from "react";
import { ChevronDown, Check, Building2 } from "lucide-react";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuLabel,
  DropdownMenuSeparator,
  DropdownMenuTrigger,
} from "../components/ui/dropdown-menu";
import { useAuth } from "../auth/AuthProvider";

export default function OrgSwitcher() {
  const { orgs, memberships, currentOrg, switchOrg } = useAuth();

  const activeOrgs = orgs
    .map((o, idx) => ({ org: o, membership: memberships[idx] }))
    .filter((row) => row.org && row.membership?.status === "active");

  if (activeOrgs.length === 0) return null;

  return (
    <DropdownMenu>
      <DropdownMenuTrigger
        data-testid="org-switcher"
        className="inline-flex items-center gap-2 px-2 sm:px-3 py-1.5 rounded-full text-sm hover:bg-zinc-100 transition-colors shrink-0"
        aria-label={`Организация: ${currentOrg?.name || ""}`}
      >
        <Building2 className="h-4 w-4 text-zinc-500 shrink-0" />
        {/* UX-18: полное название (до 160px) распирало правую группу шапки и не
            оставляло места бургеру и заголовку страницы на узком экране.
            На мобильном оставляем иконку — название всё равно видно в списке. */}
        <span className="hidden sm:inline font-medium text-zinc-900 max-w-[160px] truncate">
          {currentOrg?.name || "Организация"}
        </span>
        <ChevronDown className="h-3.5 w-3.5 text-zinc-400 shrink-0" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-64">
        <DropdownMenuLabel>Организации</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {activeOrgs.map(({ org }) => (
          <DropdownMenuItem
            key={org.id}
            onClick={() => switchOrg(org.id)}
            data-testid={`org-option-${org.id}`}
          >
            <span className="flex-1 truncate">{org.name}</span>
            {currentOrg?.id === org.id && (
              <Check className="h-4 w-4 text-primary" />
            )}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
